import { render, staticRenderFns } from "./TogglerListItem.vue?vue&type=template&id=818994a2&"
import script from "./TogglerListItem.vue?vue&type=script&lang=js&"
export * from "./TogglerListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VListItem,VListItemAction,VListItemContent,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('818994a2')) {
      api.createRecord('818994a2', component.options)
    } else {
      api.reload('818994a2', component.options)
    }
    module.hot.accept("./TogglerListItem.vue?vue&type=template&id=818994a2&", function () {
      api.rerender('818994a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/TogglerListItem.vue"
export default component.exports